import { GameAudioService } from './GameAudioService';

export const gameAudioService = new GameAudioService();
